import { AppDispatch, AppState } from '@nxsys/store';
import { timesheetsAction } from '@nxsys/store/slices/timesheets/reducer/timesheetsSlice';
import { GetListTimesheetsParams } from '@nxsys/store/slices/timesheets/type';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TimesheetsListing from './TimesheetsListing';
import { resolveFilterCompanyIds } from '@nxsys/utils/companyScope';

enum TIMESHEET_TAB {
  ALL = 'ALL',
  AWAITING_APPROVAL = 'AWAITING_APPROVAL',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

const Timesheets = () => {
  const [activeTab, setActiveTab] = useState<TIMESHEET_TAB>(TIMESHEET_TAB.ALL);

  const dispatch = useDispatch<AppDispatch>();
  const { loading, timesheetsData } = useSelector(
    (state: AppState) => state.timesheetsStore,
  );
  const { isBureauEmployer, user } = useSelector(
    (state: AppState) => state.appStore,
  );

  const getApproveStatusByTab = (tab: TIMESHEET_TAB) => {
    const tabObj = {
      [TIMESHEET_TAB.ALL]: undefined,
      [TIMESHEET_TAB.AWAITING_APPROVAL]: 'PENDING',
      [TIMESHEET_TAB.APPROVED]: 'APPROVED',
      [TIMESHEET_TAB.REJECTED]: 'CANCEL',
    };
    return tabObj[tab];
  };

  const getTimeSheetList = (params: GetListTimesheetsParams) => {
    const newParams = {
      ...params,
      approveStatus: getApproveStatusByTab(activeTab),
      companyRefs: resolveFilterCompanyIds(
        params.companyRefs,
        isBureauEmployer,
        user?.companyUserIds,
      ),
      ...(isBureauEmployer ? { noFilterByApprover: true } : {}),
    };
    dispatch(timesheetsAction.getListTimesheets(newParams));
  };

  return (
    <TimesheetsListing
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      timesheetsData={timesheetsData}
      loading={loading}
      getTimeSheetList={getTimeSheetList}
    />
  );
};

export default React.memo(Timesheets);
